// extracted by mini-css-extract-plugin
module.exports = {"oruService__inner":"HomeOurService_oruService__inner__1CFOv"};